import type { AppContextValue } from 'src/components/app-context';
import type { PublicListQuery } from '../../types';

type Props = {
  data: PublicListQuery;
};

export default ({ data }: Props, { t }: AppContextValue) => {
  if (!data?.list) return {};

  const title = data.list.user?.displayName
    ? t('meta', 'list.title', {
        name: data.list.name,
        owner: data.list.user.displayName,
      })
    : data.list.name;

  return {
    title,
    description: data.list.comment,
  };
};
